import React from "react";
import { withTranslation } from "react-i18next";

import "./DashboardWindArrow.css";

function DashboardWindArrow({ windDeg, t }) {
  if (!Number.isFinite(Number(windDeg))) return null;

  return (
    <div
      className="dashboard-wind-arrow"
      aria-hidden="true"
      title={t("Direção do vento")}
    >
      <svg
        className="dashboard-wind-arrow__svg"
        viewBox="0 0 64 64"
        style={{ transform: `rotate(${(Number(windDeg) + 180) % 360}deg)` }}
      >
        <path
          d="M32 6 L44 38 L32 32 L20 38 Z"
          fill="currentColor"
        />
        <rect x="29.2" y="30" width="5.6" height="26" rx="1.2" fill="currentColor" />
      </svg>
    </div>
  );
}

export default withTranslation()(DashboardWindArrow);
